import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import Reports from "@/views/Reports.vue";
import Requests from "@/views/Requests.vue";
import RequestForm from "@/views/RequestForm.vue";
import VideoRequests from "@/views/VideoRequests.vue";
import SelectCouncil from "@/views/SelectCouncil.vue";
import Error from "@/views/Error.vue";
import Admin from "@/views/Admin.vue";
import SignInCallback from "@/components/SignInCallback.vue";
import ensureCouncilSelected from "./councilSelectedNavigationGuard";
import ensureUserIsLoggedIn from "./userLoggedInNavigationGuard";
import ensureUserAuthorized from "./userAuthorizedNavigationGuard";
import ensureImageNotMaximized from "./imageMaximizedNavigationGuard";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/reports",
    name: "Reports",
    component: Reports,
    meta: {
      allowedRoles: ["Council Admin"]
    }
  },
  {
    path: "/admin",
    name: "Admin",
    component: Admin,
    meta: {
      allowedRoles: ["Council Admin"]
    }
  },
  {
    path: "/requests",
    name: "Requests",
    component: Requests,
    meta: {
      allowedRoles: ["Council Admin"]
    }
  },
  {
    path: "/requestform",
    name: "AddRequestform",
    component: RequestForm,
    meta: {
      allowedRoles: ["Council Admin"]
    }
  },
  {
    path: "/video-requests",
    name: "Video Requests",
    component: VideoRequests,
    meta: {
      allowedRoles: ["Council Admin", "Council Supervisor"]
    }
  },
  {
    path: "/signin-oidc",
    name: "SignInCallback",
    component: SignInCallback
  },
  {
    path: "/signin-oidc-silent",
    name: "SignInCallbackSilent",
    component: SignInCallback
  },
  {
    path: "/select-council",
    name: "SelectCouncil",
    component: SelectCouncil
  },
  {
    path: "/error",
    name: "Error",
    component: Error,
    meta: {
      isPublic: true
    }
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

router.beforeEach(ensureUserIsLoggedIn);

router.beforeEach(ensureCouncilSelected);

router.beforeEach(ensureUserAuthorized);

router.beforeEach(ensureImageNotMaximized);

export default router;
